import { useEffect, useState } from 'react';
import { Panel } from '@/components/Panel';
import { IconLock } from '@/components/icons';
import { clearQueryLog, subscribeQueryLog, type QueryLogEntry } from '@/graph/queryLog';

/**
 * Query Log (ported from x365) — the transparency proof. Every Microsoft Graph call
 * the app makes is listed here with its status and timing; there is nothing else to
 * show because there are no other network calls (zero-egress). Also the source of
 * evidence provenance.
 */
export function QueryLog() {
  const [entries, setEntries] = useState<readonly QueryLogEntry[]>([]);
  useEffect(() => subscribeQueryLog(setEntries), []);

  return (
    <Panel
      id="log"
      icon={<IconLock />}
      title="Query log"
      cap="LOG"
      why="Every Microsoft Graph call this app has made, in this browser session. There are no other network calls — this is the zero-egress proof."
      action={
        entries.length > 0 ? (
          <button className="btn btn--ghost btn--sm no-print" onClick={() => clearQueryLog()}>Clear</button>
        ) : undefined
      }
    >
      {entries.length === 0 ? (
        <p className="small muted">No Graph calls yet. Grant a module and run an audit to populate the log.</p>
      ) : (
        <table className="matrix">
          <thead>
            <tr><th>Time</th><th>Method</th><th>Endpoint</th><th>Status</th><th>ms</th></tr>
          </thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="small">{new Date(e.at).toLocaleTimeString()}</td>
                <td className="small"><code>{e.method}</code></td>
                <td className="matrix__detail"><code className="small">{e.url}</code></td>
                <td>
                  <span className={`chip ${e.status === 'error' ? 'chip--critical' : 'chip--pass'}`}>
                    {e.status}
                  </span>
                </td>
                <td className="small">{e.durationMs}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Panel>
  );
}
